<template>
  <h2>Pläne</h2>
  <schedule-create-edit-modal :pass-in-schedule="null" trigger-class="btn-success" trigger-icon="create"
                              trigger-text="Neuen Plan anlegen"></schedule-create-edit-modal>

  <VueDataTable :cols="[
                    {title: 'Start-Datum', key: 'startDate', type: 'date', sortable: true},
                    {title: 'End-Datum', key: 'endDate', type: 'date', sortable: true},
                    {title: 'Anmerkung', key: 'annotation', type: 'text'},
                    {key: 'buttons', type: 'inject', alignment: 'end'},
  ]" :data="this.scheduleStore.sortedData" :store="this.scheduleStore" caption="Liste aller Messdienerpläne"
                @sort="col_key => this.scheduleStore.sort(col_key)"
                @update="el => this.scheduleStore.updateItem(el)">
    <template #buttons="{el, id}">
      <div class="btn-group">
        <schedule-create-edit-modal :pass-in-schedule="el" trigger-class="btn-warning" trigger-icon="create"
                                    trigger-text=""></schedule-create-edit-modal>
        <button :disabled="this.scheduleStore.currently_scheduling" class="btn btn-warning"
                @click.stop="reschedule(el, false)">
          <em class="align-middle material-icons">refresh</em></button>
        <button :disabled="this.scheduleStore.currently_scheduling" class="btn btn-success"
                @click.stop="reschedule(el, true)">
          <em class="align-middle material-icons">update</em></button>
        <button class="btn btn-success" @click.stop="this.scheduleStore.downloadSchedule(id)"><em
            class="align-middle material-icons">download</em></button>
        <button class="btn btn-success" @click.stop="this.scheduleStore.copySchedule(id)"><em
            class="align-middle material-icons">content_copy</em></button>
        <button class="btn btn-danger"
                @click="this.scheduleStore.deleteItem(el, true, `den Messdienerplan vom ${el.startDate} bis zum ${el.endDate}`)">
          <em
            class="align-middle material-icons">delete</em></button>
        <router-link :to="{name: 'Plan', params: {id: id}}" class="btn btn-primary"><em
            class="align-middle material-icons">groups</em></router-link>
        <router-link :to="{name: 'PlanStatistik', params: {id: id}}" class="btn btn-primary"><em
            class="align-middle material-icons">insights</em></router-link>
        <router-link :to="{name: 'PlanAnmerkungen', params: {id: id}}" class="btn btn-primary"><em
            class="align-middle material-icons">edit_note</em></router-link>
      </div>
    </template>
  </VueDataTable>
</template>

<script>
import ScheduleCreateEditModal from "@/components/ScheduleCreateEditModal";
import {useAltarServerStore} from "@/stores/altarServer";
import {useMassStore} from "@/stores/mass";
import {useScheduleStore} from "@/stores/schedule";
import VueDataTable from "@/components/DataTable.vue";

export default {
  name: "VueSchedules",
  components: {VueDataTable, ScheduleCreateEditModal},
  methods: {
    async reschedule(schedule, preserve_current_staffing) {
      await this.scheduleStore.reschedule(schedule, preserve_current_staffing);

      // Reload masses to make sure they show the new staffing
      await this.massStore.getData();
    },
  },
  created() {
    this.scheduleStore.getData();
    if (!this.altarServerStore.loadedData)
      this.altarServerStore.getData();
    if (!this.massStore.loadedData)
      this.massStore.getData();
  },
  setup() {
    const altarServerStore = useAltarServerStore();
    const massStore = useMassStore();
    const scheduleStore = useScheduleStore();
    return {altarServerStore, massStore, scheduleStore};
  }
}
</script>